var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('rkm-form',{ref:"RkmForm"},[_c('Modulo',{attrs:{"data":{form: _vm.form, model: _vm.model}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }